<template>
    <nav class="mb-12">
        <h2 v-if="model.heading" class="mb-4">
            {{ model.heading }}
        </h2>
        <ul class="md:flex md:flex-wrap -m-4">
            <li
                v-for="element in model.navigationElements"
                :key="element.id"
                class="w-full md:w-1/2 xl:w-1/3 p-4"
            >
                <div class="relative flex flex-col h-full bg-white group hover:shadow-lg">
                     <div
                        v-if="element.image"
                    >
                        <img
                            :src="`${element.image}?width=390`"
                            :alt="element.name"
                            class="w-full h-auto"
                        />
                    </div>
                    <div
                        :class="element.color ? `tidliginn-theme-${element.color}-bg` : 'bg-gray-600'"
                        class="flex mt-auto p-4 text-center text-white group-hover:bg-green-200 group-hover:text-green-900 h-full"
                    >
                        <div class="my-auto w-full">
                            <h3
                                v-if="element.name"
                                class="text-sm font-normal"
                            >
                                {{ element.name }}
                            </h3>
                            <h4
                                v-if="element.heading"
                                class="text-base font-normal"
                            >
                                {{ element.heading }}
                            </h4>
                        </div>
                    </div>
                   <a
                        :href="element.url"
                        :target="element.target"
                        :title="element.name"
                        class="absolute top-0 left-0 h-full w-full"
                    >
                        <span class="sr-only">
                            Gå til
                            {{element.name}}
                            {{element.heading}}
                        </span>
                    </a>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: ['model']
};
</script>
